export enum EnvironmentalClass {
  Euro3 = 'Euro3',
  Euro4 = 'Euro4',
}
